import { Injectable } from '@angular/core';
import { HttpClient } from './http-client';
import { BaseEntityService } from './baseentity-service';
import { Response } from '@angular/http';


@Injectable()
export class ProductoService extends BaseEntityService {
    constructor(httpClient: HttpClient) {
        super(httpClient);
    }

    responseItemToEntity(responseItem: any): any {
        return {
            ID: responseItem.Id,
            Producto: responseItem.Producto
        };
    }
    apiRoute: string = '/api/producto';

    getProductosVisibles(userID) {
      return this.httpClient.get(`/api/producto/visibles/${userID}`)
        .map((response: Response) => {
            return response.json().ResponseData;
        });
    }

}

export interface ProductoOption {
  ID: number;
  Producto: string;
}



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/services/producto-service.ts